const Button = ({ title, icon, badge, onClick }) => {
    return (

        <button className="btn-header" onClick={onClick}>
        { icon && <i className={`fa-regular ${icon}`} /> } 
            <span>{title}</span>
        { badge && <span className="filter-indicator">{badge}</span> }
        </button>

    );
};

export default Button;
